// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import { escapeForUrl } from 'lib/common';
import './CategorySubItem.scss';

type Props = {
  name: string,
  count: number,
};

const CategorySubItem = ({ name, count }: Props) => {
  const facets = encodeURIComponent(JSON.stringify({ categories: name }));
  return (
    <Link className="CategorySubItem" to={`/search?q=&menu=products&facets=${facets}`}>
      <div className="name">{name}</div>
      <div className="counts">{count}</div>
    </Link>
  );
};

export default CategorySubItem;



// WEBPACK FOOTER //
// ./src/components/categories/CategorySubItem/CategorySubItem.js